export default __webpack_public_path__ + "static/media/icon_reset.b1313351.svg";